// src/json/overlayData.json
export const overlaySectionConcreteRestoration = {
    imageUrl: "/assets/imgs/services/8concreteRestoration/overlaySection/fondo.jpg",
    text: "The best Building Envelope Renewal /",
    highlight: "High-Rise Painting & Restoration services."
};
